export default function GenericInput({ label, value, mask }) {
  const applyMask = (value) => {
    if (mask) {
      return mask(value);
    }
    return value;
  };

  return (
    <div className="h-20">
      <label className="font-semibold text-sm">{label}:</label>
      <p className="border border-gray h-[43px] text-gray2 p-2 overflow-hidden rounded w-full bg-[#ffffff]">
        {applyMask(value)}
      </p>
    </div>
  );
}
